import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import './ActiveSlider.css'

import {
    ArrowLeftCircleIcon,
    ArrowRightCircleIcon,
} from '@heroicons/react/20/solid'

import { FreeMode, Pagination } from "swiper/modules";
import { useEffect, useRef } from "react";

function ActiveSlider(props) {
    const sliderRef = useRef()
    const { isEnglish } = props

    useEffect(() => {
        sliderRef.current?.slideTo(props.scrolledLocale)
    }, [props.scrolledLocale])

    return (
        <div className={"flex items-center justify-center"}>
            {window.innerWidth > 768 &&
                <button onClick={() => {
                    if (props.setScrolledLocale) {
                        props.setScrolledLocale(Math.max(props.scrolledLocale - 1, 0))
                    }
                    else {
                        props.setScrolledLocaleMain(Math.max(props.scrolledLocaleMain - 1, 0))
                        sliderRef.current?.slidePrev()
                    }
                }}><ArrowLeftCircleIcon aria-hidden="true" style={(props.scrolledLocale === 0 || props.scrolledLocaleMain === 0) ? { opacity: '0.3', cursor: 'auto' } : {}} className={"mr-4 h-10 w-10 flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"} /></button>
            }
            <Swiper
                onSwiper={it => (sliderRef.current = it)}
                breakpoints={{
                    500: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    780: {
                        slidesPerView: props.slides + 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: props.slides + 1,
                        spaceBetween: 30
                    },
                    1600: {
                        slidesPerView: props.slides + 2,
                        spaceBetween: 30
                    }
                }}
                freeMode={false}
                navigation={true}
                slidesPerView={props.slidesPerView || 1}
                pagination={{
                    clickable: false,
                }}
                modules={[FreeMode, Pagination]}
                className="max-w-[100%] lg:max-w-[100%]"
            >
                {props.data.map((item, index) => (
                    <SwiperSlide key={item.title}>
                        <div className={`flex md:mx-0 flex-col h-full justify-between items-end bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden transition-all duration-200 hover:shadow-lg ${props.type === 'fluid' ? 'ml-7' : 'mx-2'} ${props.type === 'fluid' && index === props.data.length - 1 ? 'mr-5' : ''}`}>
                            <div className="w-full">
                                {item.backgroundImage !== 'none' &&
                                    <div className="overflow-hidden" style={{ aspectRatio: '16/10' }}>
                                        <img alt="" src={item.backgroundImage} className="w-full h-full object-cover" />
                                    </div>
                                }
                                <div className={`${props.type === 'fluid' ? 'pt-5 pb-12' : props.simplified ? 'pt-4 pb-2' : 'p-5 sm:p-6'}`}>
                                    <h4 className="text-lg sm:text-xl leading-tight text-start font-bold text-gray-900">{item.title}</h4>
                                    {!props.simplified && <p className="mt-3 text-sm sm:text-base text-start leading-6 text-gray-600">{item.text}</p>}
                                </div>
                            </div>
                            {!props.simplified && item.period &&
                                <div className="px-5 pb-5 w-full">
                                    <span className="inline-flex items-center rounded-full bg-brand-50 px-3 py-1.5 text-xs sm:text-sm font-semibold text-brand-700 ring-1 ring-inset ring-brand-700/10">
                                        {item.period}
                                    </span>
                                </div>
                            }
                        </div>
                    </SwiperSlide>
                ))
                }
            </Swiper>
            {
                window.innerWidth > 768 &&
                <button onClick={() => {
                    if (props.setScrolledLocale) {
                        props.setScrolledLocale(Math.min(props.scrolledLocale + 1, props.data.length - 1))
                    }
                    else {
                        props.setScrolledLocaleMain(Math.min(props.scrolledLocaleMain + 1, 2))
                        sliderRef.current?.slideNext()
                    }
                }}><ArrowRightCircleIcon style={(props.scrolledLocale === props.data.length - 1 || props.scrolledLocaleMain === 2) ? { opacity: '0.3', cursor: 'auto' } : {}} aria-hidden="true" className="ml-4 h-10 w-10 flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors" /></button>
            }
        </div>
    );
}

export default ActiveSlider
